import { init } from "../init";
import { JiraLandingPage } from "../pages/jira/jira-landing-page";
init(JiraLandingPage);
